import { render } from "./PDFClienteInformacao.vue?vue&type=template&id=5fbca5b3&scoped=true"
import script from "./PDFClienteInformacao.vue?vue&type=script&lang=js"
export * from "./PDFClienteInformacao.vue?vue&type=script&lang=js"

import "./PDFClienteInformacao.vue?vue&type=style&index=0&id=5fbca5b3&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fbca5b3"]])

export default __exports__